import { CreationIcon } from './CreationIcon';

/**
 * author: Google
 * id 598B7931-3DF8-4CFA-A6E6-80550CA31372
 * name creation
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/creation.svg
 * tags
 */
export const SparklesIcon = CreationIcon;
export default SparklesIcon